import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table table-responsive-md border border-gray" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "First Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Last Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Role"),
    /*#__PURE__*/_createElementVNode("th", null, "Relationship"),
    /*#__PURE__*/_createElementVNode("th", null, "Primary Phone"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Primary Emergency Contact"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Other Emergency Contact"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Bereavement Contact"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions")
  ])
], -1 /* HOISTED */)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "table-empty"
}
const _hoisted_7 = ["colspan"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "No Contacts Found.", -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "table-error"
}
const _hoisted_11 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_AuthorizedContactsRow = _resolveComponent("AuthorizedContactsRow")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    (_ctx.isLoading || _ctx.isError || !_ctx.hasData)
      ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
          _createCommentVNode(" LOADING "),
          (_ctx.isLoading)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.loadingCount, (i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: i,
                  class: "table-loading"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                    return (_openBlock(), _createElementBlock("td", { key: i }, _hoisted_5))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" EMPTY "),
          (!_ctx.isLoading && !_ctx.isError && !_ctx.hasData)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_9, 8 /* PROPS */, _hoisted_7)
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" ERROR "),
          (!_ctx.isLoading && _ctx.isError)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                _createElementVNode("td", { colspan: _ctx.columns }, [
                  _createVNode(_component_ErrorMessageHandler, {
                    title: "Contact list",
                    "try-again": _ctx.getContacts
                  }, null, 8 /* PROPS */, ["try-again"])
                ], 8 /* PROPS */, _hoisted_11)
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.contacts, (contact, index) => {
          return (_openBlock(), _createBlock(_component_AuthorizedContactsRow, {
            key: contact,
            contact: contact,
            index: index,
            "is-re-order-requested": _ctx.isReOrderRequested,
            "patient-primary-address": _ctx.patientPrimaryAddress,
            columns: _ctx.columns,
            "patient-id": _ctx.patientId,
            "total-contacts": _ctx.totalContacts,
            "onUpdate:total-contacts": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.totalContacts) = $event)),
            "relationships-enum": _ctx.relationshipsEnum,
            "contact-roles-enum": _ctx.contactRolesEnum,
            "refresh-list": _ctx.getContacts,
            "move-up": _ctx.moveUp,
            "move-down": _ctx.moveDown,
            "update-contact": _ctx.updateAuthorizedContact,
            "delete-authorized-contact": _ctx.deleteAuthorizedContact
          }, null, 8 /* PROPS */, ["contact", "index", "is-re-order-requested", "patient-primary-address", "columns", "patient-id", "total-contacts", "relationships-enum", "contact-roles-enum", "refresh-list", "move-up", "move-down", "update-contact", "delete-authorized-contact"]))
        }), 128 /* KEYED_FRAGMENT */))
  ]))
}